/*
 * Copyright 2013-2020 Virtru Corporation
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
module.exports = {
  encode: str => {
    let hex = '';
    for (let i = 0; i < str.length; i++) {
      hex += `${str.charCodeAt(i).toString(16)}`;
    }
    return hex;
  },
  decode: hex => {
    let str = '';
    for (let i = 0; i < hex.length; i += 2) {
      str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    }
    return str;
  }
};
